export default {
    updateEditorDialogOpen(state, payload) {
        state.editorDialogOpen = payload;
    },

    updateEditorIsPreview(state, payload) {
        state.editorIsPreview = payload;
    },

    updateImageGalleryOpen(state, payload) {
        state.imageGalleryOpen = payload;
    },

    updateCloneDialogOpen(state, payload) {
        state.cloneDialogOpen = payload;
    },

    updatePreviewDialogOpen(state, payload) {
        state.previewDialogOpen = payload;
    },

    updateSelectDialogOpen(state, payload) {
        state.selectDialogOpen = payload;
    },

    updateIsSaving(state, payload) {
        state.isSaving = payload;
    },

    updateFormData(state, payload) {
        state.formData = Object.assign({}, state.formData, payload);
    },

    updateCloneMediaObjectId(state, payload) {
        state.cloneMediaObjectId = payload;
    },

    updateCloneMediaObject(state, payload) {
        state.cloneMediaObject = Object.assign({}, state.cloneMediaObject, payload);
    },

    updateImages(state, payload) {
        state.images = payload;
    },

    unshiftImages(state, payload) {
        state.images.unshift(payload);
    },

    updateLoading(state, payload) {
        Object.assign(state.loading, payload);
    },

    updateCloneFormData(state, payload) {
        state.cloneFormData = Object.assign({}, state.cloneFormData, payload);
    },

    updateBaseCss(state, payload) {
        state.baseCss = payload;
    },

    updateAceEditor(state, payload) {
        state.aceEditor = payload;
    },

    updateHasChanges(state, payload) {
        state.hasChanges = payload;
    },

    updateActiveTab(state, payload) {
        state.activeTab = payload;
    },

    addPage(state, payload) {
        state.pages.push(payload);
    },

    removePage(state, payload) {
        const index = state.pages.findIndex(item => {
            return item.cid === payload;
        });

        state.pages.splice(index, 1);
    },

    updateActivePage(state, payload) {
        state.activePage = payload;
    },

    updateEditorDialogSilentOpen(state, payload) {
        state.editorDialogSilentOpen = payload;
        state.editorDialogOpen = payload;
    },

    // we need the editor dialog to open while not showing in order to grab the html rendered,
    // in the iframe since textfill is being done on it
    silentOpenEditorDialog(state, payload) {
        if (!state.editorDialogOpen) {
            state.editorDialogSilentOpen = true;
            state.editorDialogOpen = true;
        }
    },

    silentCloseEditorDialog(state, payload) {
        if (state.editorDialogSilentOpen) {
            state.editorDialogOpen = false;

            // wait for the dialog animation to be done so we dont get a flash
            setTimeout(() => {
                state.editorDialogSilentOpen = false;
            }, 400)
        }
    },

    updateComarketableContent(state, payload) {
        state.comarketableContent = payload;
    },

    updateHasPage(state, payload) {
        state.hasPage = payload;
    },

    updateHasSectionContainer(state, payload) {
        state.hasSectionContainer = payload;
    }

}

